<template>
    <transition name="pro-nav-dropdown-fade">
        <div v-show="isActive" class="pro-nav__shadow" :style="{ height: `${height}px` }">
            <div class="pro-nav__shadow-indicator" :style="{ right: `${offset}px` }"></div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            offset: "navigation/getOffset",
            isActive: "navigation/getIsActive",
            height: "navigation/getHeight",
        }),
    },
};
</script>
